// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7337) return "static/chunks/ad2866b8-d29eef21901316b3.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8445 ? "bc98253f" : chunkId) + "." + {"3969":"640b626f4009d884","6784":"8594c41c47221e37","8445":"f6efc8d1e0028bf6","8848":"3fa771a15406f102","9108":"a2b794898bd65271"}[chunkId] + ".js";
};